import React from 'react'

export default function Divider() {
  return (
    <div className='w-full flex justify-center my-6 md:my-12'>
        <div className='w-full border-t'></div>
    </div>
  )
}
